import HotelManualEvent from '../../event/HotelManualEvent'
import AppDispatcher from '../../core/AppDispatcher'

const onClear = () => {
  AppDispatcher.dispatchWithType(HotelManualEvent.onClear)
  return true
}

export default onClear
